import {BaseContainerModel} from '../../base-container.model';
import {
  bl_crm_membership_hdr_RowClass,
  bl_fi_entity_hdr_RowClass,
  bl_fi_entity_hdr_RowInterface,
  bl_fi_mst_entity_ext_RowInterface,
  bl_fi_mst_entity_line_RowInterface,
  bl_fi_mst_entity_login_subject_link_RowClass
} from '../../../dbschema/index';

export class EntitymembershipContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowInterface = new bl_fi_entity_hdr_RowClass();
  bl_fi_mst_entity_line: bl_fi_mst_entity_line_RowInterface[] = [];
  bl_fi_mst_entity_ext: bl_fi_mst_entity_ext_RowInterface[] = [];
  bl_fi_mst_entity_login_subject_links:  bl_fi_mst_entity_login_subject_link_RowClass[] = [];
  bl_crm_membership_hdr: bl_crm_membership_hdr_RowClass [] = [];
}
